import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { appConfig } from '../config'
import { arrayFindNext } from '../utils'
import { availableLocales } from '../constants/locale'
import type { Language } from '../types/locale'

export const useLocaleStore = defineStore('app.locale', () => {
  const language = ref(appConfig.locale.language as Language)

  function switchLanguage(newLang?: Language) {
    language.value = newLang ?? arrayFindNext(availableLocales, language.value)
  }

  function $reset() {
    switchLanguage()
  }

  return {
    language,
    switchLanguage,
    $reset,
  }
})
